exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html {\n    scroll-behavior: smooth;\n    overflow-y: scroll;\n}\n\na {\n    outline: 0;\n    color: inherit; /* blue colors for links too */\n    text-decoration: inherit; /* no underline */\n}\n\nhtml, body {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n}\n\nbody {\n    font-family: sans-serif;\n    font-size: large;\n    overflow: visible !important;\n}\n\nhtml, body, #app {\n    height: 100%;\n}\n", ""]);

// exports
